import RoutesComponent from "./widgets/Routes";
import WidgetModal from "./widgets/Modal";
import WidgetToast from "./widgets/Toast";

const App = () => {
    return (
        <>
            <RoutesComponent />
            <WidgetModal />
            <WidgetToast />
        </>
    );
};

export default App;
